<div class="performance-total-wrapper">
  <div class="total-wrapper">
    <span class="title">Q{{ queuer()?.quarter }} {{ queuer()?.year }} Scorecard</span>
  </div>

  <div class="values-wrapper">
    <div class="value-wrapper">
      <div class="value">{{ queuer()?.epsWeBeatThem | forecastPercentNumber: 1 }}</div>
      <div class="title">EPS win rate</div>
    </div>
    <div class="value-wrapper">
      <div class="value">{{ queuer()?.revWeBeatThem | forecastPercentNumber: 1 }}</div>
      <div class="title">Revenues win rate</div>
    </div>
    <div class="value-wrapper">
      <div class="value">{{ queuer()?.companyCount | forecastNumber }}</div>
      <div class="title">Companies reported</div>
    </div>
  </div>
</div>
